<template>
    <section class="pa-card">
        <div class="pa-header">
            <i class="fal fa-clipboard-list text-blue-500"></i>
            <div>
                <h2 class="text-lg leading-6 font-medium text-blue-500 mb-0">
                    {{ $t('post.page.information.contextual') }}
                </h2>
                <p class="pa-subtitle">{{ $t('post.page.information.detail') }}</p>
            </div>
        </div>
        <div class="pa-body">
            <div v-for="answer in post.answers" :key="answer.id">
                <div
                    class="pa-answer"
                    v-if="
                        answer.name !== 'gdpr' &&
                        isValueEmpty(answer.value) &&
                        isContentOrTitle(answer.config) &&
                        answer.hidden !== 1
                    "
                >
                    <component
                        :medias="post.medias"
                        :is="resolveComponent(answer.name)"
                        :value="answer"
                        :post="post"
                    />
                </div>
            </div>
        </div>
    </section>
</template>

<script>
/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
import { mapState } from 'vuex'
import MapPostCard from '@/components/Model/Map/MapPostCard'
import ClassicAttribute from './Attribute/ClassicAttribute'
import CategoryAttribute from './Attribute/CategoryAttribute'
import FileUploadAttribute from './Attribute/FileUploadAttribute'
import CheckboxAttribute from './Attribute/CheckboxAttribute'
import AudioAttribute from './Attribute/AudioAttribute'
import RatingAttribute from './Attribute/RatingAttribute'

export default {
  name: 'PostAnswers',
  components: {
    location: MapPostCard,
    category: CategoryAttribute,
    gdpr: CheckboxAttribute,
    smalltext: ClassicAttribute,
    'textarea-field': ClassicAttribute,
    email: ClassicAttribute,
    markdown: ClassicAttribute,
    'file-upload': FileUploadAttribute,
    'audio-field': AudioAttribute,
    rating: RatingAttribute,
    'select-field': ClassicAttribute,
    checkbox: CheckboxAttribute,
    radio: CheckboxAttribute,
    date: ClassicAttribute,
    datetime: ClassicAttribute,
    number: ClassicAttribute,
    query: ClassicAttribute,
    'geolocation-automatic': MapPostCard
  },
  computed: {
    ...mapState('post', {
      post: (state) => state.post,
      postHistories: (state) => state.postHistories
    })
  },
  methods: {
    resolveComponent(name) {
      if (name === 'audio') return 'audio-field'
      if (name === 'textarea') return 'textarea-field'
      return name
    },
    isValueEmpty(value) {
      if (value) {
        if (typeof value === 'string') {
          return value !== ''
        } else if (typeof value === 'object') {
          return value.length > 0 || Object.keys(value).length > 0
        }
        else {
          return value
        }
      } else {
        return false
      }
    },
    isContentOrTitle(config) {
      return !(
        JSON.parse(config).as == 'title' ||
        JSON.parse(config).as == 'content'
      )
    }
}
}
</script>
<style scoped>
.pa-card {
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.pa-header {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 16px 24px;
    border-bottom: 1px solid #f1f5f9;
}

.pa-header > i {
    font-size: 1rem;
    margin-top: 3px;
    flex-shrink: 0;
}

.pa-subtitle {
    font-size: 0.8rem;
    color: #94a3b8;
    margin: 2px 0 0;
}

.pa-body {
    padding: 0;
}

.pa-answer {
    padding: 16px 24px;
    border-bottom: 1px solid #f1f5f9;
}

.pa-answer:last-child {
    border-bottom: none;
}
</style>
